import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsStandUpPaddlingNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      viewBox="0 0 48 48"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g
        clipPath="url(#sports_stand_up_paddling_normal_large_svg__clip0_138_60)"
        fill=""
      >
        <path d="M28-.013a5.9 5.9 0 00-5.19 3.025A29.369 29.369 0 0019 17.465a85.228 85.228 0 003.137 22.913l1.546 5.54A2.854 2.854 0 0026.424 48h3.152a2.854 2.854 0 002.741-2.082l1.546-5.54A85.24 85.24 0 0037 17.466 29.373 29.373 0 0033.19 3.01 5.9 5.9 0 0028-.013zm3.937 39.855l-1.546 5.539a.85.85 0 01-.815.619h-3.152a.848.848 0 01-.815-.62l-1.546-5.54A83.28 83.28 0 0121 17.466 27.375 27.375 0 0124.55 4a3.965 3.965 0 016.9 0A27.382 27.382 0 0135 17.465c0 7.563-1.03 15.092-3.063 22.377zM10.715 38.8l-.872 5.748A3 3 0 0012.81 48h2.159a2.999 2.999 0 002.979-3.369l-.708-5.74A3.29 3.29 0 0015 36.176V4.012h1v-2h-4v2h1v32.144a3.262 3.262 0 00-2.285 2.644zm3.257-.8a1.294 1.294 0 011.283 1.135l.708 5.741A.999.999 0 0114.97 46h-2.16a1 1 0 01-.99-1.152l.873-5.748a1.287 1.287 0 011.279-1.1z" />
        <path d="M27 19.086a5.1 5.1 0 00-4 5.075c0 3.97.593 7.92 1.762 11.714L26.646 42h2.708l1.884-6.125A39.786 39.786 0 0033 24.16v-.172a4.999 4.999 0 00-6-4.9v-.002zm4 5.074c0 3.772-.564 7.523-1.673 11.128L28 39.6l-1.327-4.311A37.799 37.799 0 0125 24.161a3.133 3.133 0 012.385-3.112c.204-.04.412-.06.62-.061a2.963 2.963 0 011.9.683A3 3 0 0131 23.988v.172z" />
      </g>
      <defs>
        <clipPath id="sports_stand_up_paddling_normal_large_svg__clip0_138_60">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsStandUpPaddlingNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsStandUpPaddlingNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsStandUpPaddlingNormalLarge;
